import { BaseRequest } from "../../../base/request/BaseRequest";
import { BaseResponse } from "../../../base/response/BaseResponse";
import { serviceProvider } from "../../../comun/provider/ServiceProvider";
import { CardConnectRender } from "../../base/card/CardConnectRender";
import { CardBody } from "../../definitions/card/CardBody";
import { CardFooter } from "../../definitions/card/CardFooter";
import { CardHeader } from "../../definitions/card/CardHeader";
import { IFormField } from "../../definitions/form/IFormField";
import { FormCardConfig } from "../../definitions/card/FormCardConfig";

export class FormCardRender<
  TRequest extends BaseRequest,
  TResponse extends BaseResponse,
> extends CardConnectRender {
  private readonly _request: TRequest;
  private readonly _config: FormCardConfig<TRequest, TResponse>;
  private readonly _formFields: IFormField[];

  constructor(request: TRequest, config: FormCardConfig<TRequest, TResponse>) {
    super();
    this._request = request;
    this._config = config;
    this._backAction = this._config.cancelAction;
    this._formFields = config.createFormFields(request);
  }

  protected getCardHeader(): CardHeader {
    return this._config.cardHeader;
  }

  protected getCardBody(): CardBody {
    return {
      additionalCssClass: this._config.additionalCardBodyCssClass ?? "",
      content: this._formFields
        .map((field) => {
          return field.render();
        })
        .join(""),
    };
  }

  protected getCardFooter(): CardFooter | null {
    return {
      additionalCssClass: this._config.cancelAction
        ? "sx-card-footer--actions"
        : "",
      content: this._getFooterContent(),
    };
  }

  protected afterConnect(): void {
    this._formFields.forEach((formField) => {
      formField.connect();
    });

    document
      .getElementById(`form-cancel-${this._cardId}`)
      ?.addEventListener("click", () => {
        if (this._config.cancelAction) this._config.cancelAction();
      });
    const btnSubmit = document.getElementById(
      `form-submit-${this._cardId}`,
    )! as HTMLButtonElement;
    btnSubmit.addEventListener("click", () => {
      let isValid = true;
      this._formFields.forEach((formField) => {
        formField.showError();
        if (formField.getError()) {
          if (!isValid) formField.focus();

          isValid = false;
        }
      });
      if (!isValid) {
        return;
      }

      btnSubmit.disabled = true;
      this._config.saveService
        .saveAsync(this._request)
        .then((response) => {
          this._config.onSubmitEnd(response);
          if (this._backAction) {
            this._backAction();
          }
        })
        .catch((error) => {
          serviceProvider.getErrorService().addError("Error al guardar", error);
        })
        .finally(() => {
          this._formFields.forEach((formField) => {
            formField.enabled();
          });
          btnSubmit.disabled = false;
        });
    });
  }

  protected beforeDispose(): void {
    this._formFields.forEach((formField) => {
      formField.dispose();
    });
  }

  private _getFooterContent(): string {
    if (!this._config.cancelAction) {
      return `<button class="sx-btn sx-btn-primary sx-btn-block" type="button" id="form-submit-${this._cardId}">${this._config.submitText}</button>`;
    }
    return `
        <button class="sx-btn sx-btn-ghost" type="button" id="form-cancel-${this._cardId}">Cancelar</button>
        <button class="sx-btn sx-btn-primary" type="button" id="form-submit-${this._cardId}">${this._config.submitText}</button>`;
  }
}
